<template>

    <MenuMain v-if="this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)"/>
    <MenuMain v-if="this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)"/>
    <MenuUserModuleMain v-if="this.userStore.user.roles.includes('ROLE_USER', 0)"/>
    <HeadingApplications/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>IsoEvolve CPD Application #1</h3>

                    <div class="font-bold text-900 text-3xl mb-3 text-center">Four Courses</div>
                    <div class="text-700 text-center mb-3">31 CPD Points (25 Clinical CEUs, 6 Ethical CEUs)</div>

                    <div class="flex flex-wrap">
                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-1.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Modalities of Therapy (Modules 1 to 8)
                            </div>
                            <span class="text-700 line-height-3">8 x Clinical CEUs (HPCSA Level 1), 1 x Ethical CEU (HPCSA Level 1)</span>
                            <a @click="callCourse1" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>

                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-2.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Special Interest Series :: ADHD (Modules
                                1
                                to 3)
                            </div>
                            <span class="text-700 line-height-3">3 x Clinical CEUs (HPCSA Level 1)</span>
                            <a @click="callCourse2" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>

                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-3.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Special Interest Series :: Disorders
                                (Modules 1
                                to 14)
                            </div>
                            <span class="text-700 line-height-3">14 x Clinical CEUs (HPCSA Level 1)</span>
                            <a @click="callCourse3" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>

                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-4.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Private Practice Management</div>
                            <span class="text-700 line-height-3">5 x Ethical CEUs (HPCSA Level 1)</span>
                            <a @click="callCourse4" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #1 :: Modalities of Therapy (Modules 1 to 8)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <Accordion>
                        <AccordionTab header="Course #1 :: Module #1 :: BrainWorking® Recursive Therapy (BWRT)">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #1 :: BrainWorking® Recursive Therapy (BWRT)</h2>

                                        <h3>Accreditation number : AOCP001/5730/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>
                                        <h4>1 Ethics CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #1 :: Module #2 :: Music Therapy">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #2 :: Music Therapy</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #3 :: Hypnotherapy">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #3 :: Hypnotherapy</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #4 :: Burnout and CBT">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #4 :: Burnout and CBT</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #5 :: Play Therapy with an Educational Psychologist">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #5 :: Play Therapy with an Educational Psychologist</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #6 :: Contextual Therapy">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #6 :: Contextual Therapy</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #7 :: Hippotherapy and Sensory Integration Disorder from an Occupational Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #7 :: Hippotherapy and Sensory Integration Disorder from an Occupational Therapist’s Perspective</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #8 :: Hand Therapy from an Occupational Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #8 :: Hand Therapy from an Occupational Therapist’s Perspective</h2>

                                        <h3>Accreditation number : AOCP001/5731/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                    </Accordion>


                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #2 :: Special Interest Series :: ADHD (Modules 1 to 3)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <Accordion>
                        <AccordionTab header="Course #2 :: Module #1 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #2 :: Module #1 :: </h2>

                                        <h3>Accreditation number : AOCP001/5732/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #2 :: Module #2 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #2 :: Module #2 :: </h2>

                                        <h3>Accreditation number : AOCP001/5732/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #2 :: Module #3 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #2 :: Module #3 :: </h2>

                                        <h3>Accreditation number : AOCP001/5732/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                    </Accordion>


                </div>
            </div>
        </div>


        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #3 :: Special Interest Series :: Disorders (Modules 1 to 14)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <Accordion>
                        <AccordionTab header="Course #3 :: Module #1 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #1 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #2 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #2 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #3 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #3 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #4 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #4 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #5 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #5 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #6 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #6 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #7 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #7 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #8 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #8 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #9 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #9 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #10 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #10 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #11 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #11 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #12 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #12 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #13 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #13 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #3 :: Module #14 :: ">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #14 :: </h2>

                                        <h3>Accreditation number : AOCP001/5733/12/2025</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                    </Accordion>


                </div>
            </div>
        </div>


        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #4 :: Private Practice Management</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="card p-fluid">

                                <h2>Course #4 :: Private Practice Management</h2>

                                <h3>Accreditation number : AOCP001/5734/12/2025</h3>

                                <h4>5 Ethics CEUs, HPCSA Level 1</h4>

                                <br><br>
                                The running of a healthcare private practice is a difficult transition for most healthcare practitioners.
                                In this course, we review the HPCSA
                                guidelines and provide insight and actionable learnings to help any healthcare practitioner with their
                                private practice management.

                                <br><br>
                                Our Presenter, Ingrid James, will be introducing the concepts, as well as discussing the applications of
                                each area within a healthcare private practice.

                                <br><br>
                                <h3>Aims of the Programme</h3>
                                1. Strategy and mapping out your journey.<br>
                                2. Ethical considerations.<br>
                                3. Marketing considerations.<br>
                                4. Legal considerations.<br>
                                5. People and human resources considerations.<br>
                                6. Processes and operational functional considerations.<br>
                                7. Billing, financials and tax considerations.<br>
                                8. Continuous learning and educational considerations.<br>
                                9. Coaching and mentorship considerations.<br>
                                10. Tools and resources.

                                <br><br>
                                The assessment of the understanding of the module is followed by a questionnaire (10 items).
                                Based on the answers to the assessment, a certificate will be issued for your records
                                confirming the CPD points.

                                <br><br><br><br>

                                <h3>Biography of Ingrid James</h3>
                                Clinical Psychologist<br>
                                MA (Clin Psychology) Zululand<br>

                                <br><br>
                                Ingrid is a Senior Clinical Psychologist, with special interest in the maintenance of well-being and the
                                prevention of mental illness.
                                She has been in private practice since 2005 based in Gauteng, South Africa.

                                <br><br>
                                She trained at the University of Zululand in a community psychology based programme. Zululand in Northern
                                KwaZulu Natal and its
                                surrounding areas is a predominantly mining area where supporting towns sprang up as a result of migrant
                                employees. The aim of
                                the University in developing the community psychology programme was to create support for the displaced
                                migrant employees,
                                facilitate tolerance in this cultural melting pot, and most of all create an environment of physical and
                                emotional well-being
                                for the employees and their families.

                                <br><br>
                                She was initially moved to concentrate on well-being and prevention of mental illness during my internship
                                where I worked
                                as a consultant psychologist to companies such as Mondi (Richards Bay and Empangeni), South African Ports
                                Authority (Portnet),
                                Ticor and Richards Bay Coal Terminal (RBCT). She was responsible for the Employee Assistance Programme
                                (EAP) in each of these
                                companies and was confronted on a daily basis with individuals who struggled to cope with their unfamiliar
                                environments and
                                the demands of work. The research for her Master’s Thesis was The Effect of Exercise on Psychological
                                Well-Being in the Workplace.

                                <br><br>
                                During the course of her practice, she has dealt with a number of clients with work related difficulties.
                                She was instrumental
                                in establishing the EAP programme in a medical hospital during my Community Service. After establishing a
                                successful private practice,
                                she branched out into Coaching and received accreditation through Success Factory. This was mainly due to
                                the yearning to be able to
                                intervene at an earlier stage of distress.

                                <br><br>
                                She is an internationally accredited assessor of the EQ-i and MBTI New. Her training as a clinical
                                psychologist, exposure to
                                coaching and work experience equips her to understand the relationships of individuals both with
                                themselves and each other.
                                She excels at managing difficult situations through her attitude, professionalism and ethical point of
                                view.

                                <br><br>
                                <h3>Contact Details</h3>
                                Mobile Number :: 0825576793<br>
                                Practice Address :: 55A Albatross Drive, Fourways, Gauteng, 2055<br>
                                Email :: ingrid@ingridnagaya.com<br>
                                Website:: www.ingridnagaya.com

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #1</h3>
                                <div>
                                    <div class="video-container">
                                        <iframe width="640" height="480" src="https://www.youtube.com/embed/19b-13Gac5s" frameborder="0"
                                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #2</h3>
                                <div>
                                    <div class="video-container">
                                        <iframe width="640" height="480" src="https://www.youtube.com/embed/V3ywRZXlK-U" frameborder="0"
                                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #3</h3>
                                <div>
                                    <div class="video-container">
                                        <iframe width="640" height="480" src="https://www.youtube.com/embed/rH6pl_h4yl4" frameborder="0"
                                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #4</h3>
                                <div>
                                    <div class="video-container">
                                        <iframe width="640" height="480" src="https://www.youtube.com/embed/gEnHxpYwwn0" frameborder="0"
                                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #5</h3>
                                <div>
                                    <div class="video-container">
                                        <iframe width="640" height="480" src="https://www.youtube.com/embed/g_vayAPTL3s" frameborder="0"
                                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #1</h3>
                                <div>
                                    <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333001971&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank" style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-41" title="Kitrin IsoLearn :: Private Practice Management :: Module 4.1" target="_blank" style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn :: Private Practice Management :: Module 4.1</a></div>
                                </div>

                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #2</h3>
                                <div>
                                    <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333002253&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank" style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-42" title="Kitrin IsoLearn :: Private Practice Management :: Module 4.2" target="_blank" style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn :: Private Practice Management :: Module 4.2</a></div>
                                </div>

                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #3</h3>
                                <div>
                                    <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333002754&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank" style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-43" title="Kitrin IsoLearn :: Private Practice Management :: Module 4.3" target="_blank" style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn :: Private Practice Management :: Module 4.3</a></div>
                                </div>

                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #4</h3>
                                <div>
                                    <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333003717&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank" style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-44" title="Kitrin IsoLearn :: Private Practice Management :: Module 4.4" target="_blank" style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn :: Private Practice Management :: Module 4.4</a></div>
                                </div>

                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #5</h3>
                                <div>
                                    <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333004299&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank" style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-45" title="Kitrin IsoLearn :: Private Practice Management :: Module 4.5" target="_blank" style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn :: Private Practice Management :: Module 4.5</a></div>
                                </div>

                                <div>
                                    <br><br><br><br>
                                    <h3>Complete Questionnaire for Course 4</h3>

                                    <div class="field">
                                        <label for="question1">1. Can you use the expression "hospital", "clinic" or "institute" in your practice name?</label>
                                        <Dropdown v-model="course4.answer1" :options="course4Question1" optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question2">2. How many core ethical values and standards are there in terms of clinical practice?</label>
                                        <Dropdown v-model="course4.answer2" :options="course4Question2" optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question3">3. Can information on a patient be shared on social media platforms (if no consent is received from patient)?</label>
                                        <Dropdown v-model="course4.answer3" :options="course4Question3" optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question4">4. Can a practitioner divulge information regarding a patient under certain circumstances?</label>
                                        <Dropdown v-model="course4.answer4" :options="course4Question4" optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question5">5. How long can a practitioner employ a locum tenen?</label>
                                        <Dropdown v-model="course4.answer5" :options="course4Question5" optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <Button label="Submit" class="mr-2 mb-2" @click="submitQuestionnaireCourse4"></Button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>


<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import HeadingApplications from "@/components/heading/common/HeadingApplications.vue";
import MenuMain from "@/components/menu/common/MenuMain.vue";
import MenuUserModuleMain from "@/components/menu/usermodule/MenuUserModuleMain.vue";
import CourseAssessmentService from "@/service/CourseAssessmentService";


export default {
    components: {
        MenuUserModuleMain, HeadingApplications, MenuMain,
        IsoEvolveFooter
    },

    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return; // Exit early if getUser fails
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
        }
    },
    data() {
        return {
            profile: {},
            submitted: false,
            activeTab: 1,
            course4: {},
            course4Question1: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course4Question2: [
                {name: 'A. One', code: 'A'},
                {name: 'B. Five', code: 'B'},
                {name: 'C. Thirteen', code: 'C'},
                {name: 'D. Sixteen', code: 'D'},
                {name: 'E. Twenty', code: 'E'},
            ],
            course4Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course4Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course4Question5: [
                {name: 'A. One Month', code: 'A'},
                {name: 'B. One Year', code: 'B'},
                {name: 'C. Six Months', code: 'C'},
                {name: 'D. Six Years', code: 'D'},
                {name: 'E. Nine Months', code: 'E'},
            ],
        }
    },
    methods: {
        callHome() {
            this.activeTab = 1;
        },
        callCourse1() {
            this.activeTab = 2;
        },
        callCourse2() {
            this.activeTab = 3;
        },
        callCourse3() {
            this.activeTab = 4;
        },
        callCourse4() {
            this.activeTab = 5;
        },
        submitQuestionnaireCourse4() {

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course4.answer1,
                answer2: this.course4.answer2,
                answer3: this.course4.answer3,
                answer4: this.course4.answer4,
                answer5: this.course4.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 125, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdModule4][submitQuestionnaireModule1] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Module 4. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdModule4][submitQuestionnaireModule1] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Module 4. Answers are NOT Correct.",
                        life: 3000
                    })
                });


        }

    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
<script setup>
</script>
